export default __webpack_public_path__ + "static/media/SyncIcon.ec82c695.svg";